/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

import themConfigs from 'config/theme';

const fullConfig = { theme: themConfigs };

const ServicePageFigure = styled.figure`
  height: 150px;

  @media (min-width: ${fullConfig.theme.screens.md}) {
    min-height: 280px;
  }
`;

const ReadMoreLink = styled.a``;

const CheckListElem = styled.li`
  &::before {
    content: '';
    display: inline-block;
    min-height: 1rem;
    min-width: 1rem;
    background-image: url('/assets/svg/check-mark.svg');
    background-size: contain;
    margin-right: 1rem;
  }
`;

const ServiceLinkWrapElem = styled.li`
  &::before {
    transition: margin 150ms;
    content: '';
    display: inline-block;
    min-height: 0.625rem;
    min-width: 0.625rem;
    background-image: url('/assets/svg/service-link.svg');
    background-size: contain;
    background-repeat: no-repeat;
    margin-right: 0.5rem;
  }
  &:hover::before {
    margin-right: 0.25rem;
    margin-left: 0.25rem;
  }
`;

const ServiceLinkElem = styled.a``;

export { ServicePageFigure, ReadMoreLink, CheckListElem, ServiceLinkElem, ServiceLinkWrapElem };
